import { useRef } from 'react';
import { GuidService } from 'ui-components/services/guid-service';

export const useUniqueHtmlId = (prefix) => {
  const id = useRef(`${prefix}-${GuidService.newGuid()}`);
  return id.current;
};
